import report_filters from '@/store/reports/report_filters'
import report_income from '@/store/reports/report_income'
import report_expense from '@/store/reports/report_expense'

export default {
    namespaced: true,
    modules: {
        report_filters,
        report_income,
        report_expense,
    }
}